import { render, staticRenderFns } from "./VkuSignupForm.vue?vue&type=template&id=48092085&"
import script from "./VkuSignupForm.vue?vue&type=script&lang=js&"
export * from "./VkuSignupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports